export const ACTIONS = {
  SET_START_SPEED_TEST: 'SET_START_SPEED_TEST',
  CLEAR_START_SPEED_TEST: 'CLEAR_START_SPEED_TEST',
};

export const setStartSpeedTest = () => {
  return dispatch =>
    dispatch({
      type: ACTIONS.SET_START_SPEED_TEST,
    });
};

export const clearStartSpeedTest = () => {
  return dispatch =>
    dispatch({
      type: ACTIONS.CLEAR_START_SPEED_TEST,
    });
};
